module.exports = __webpack_public_path__ + "static/media/book2cover_preview.b7be6f75.png";